export enum StorageNameSpace {
    ORDER_NOTIFICATIONS = 'qwic_order_notifications',
    NEWS = 'qwic_news',
    PERSISTENT = 'qwic_persistent',
    REDIRECTION = 'qwic_redirection',
    USER = 'qwic_sf_user',
    IMPERSONATION = 'qwic_impersonation',
}
